<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-scadenzari page-operative-data-analysis-scadenzari-list d-flex flex-column h-100">
    <div class="flex-grow-1 container-fluid d-flex flex-column h-100">
      <div class="d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap mb-5">
        <PageTitle class="mb-2 mb-md-0">Scadenzari</PageTitle>

        <app-router-link v-if="userCanEdit" class="btn btn-primary" :to="{ name: 'operative-company.data-analysis.scadenzari.add' }">
          Aggiungi scadenzario
        </app-router-link>
      </div>

      <div class="flex-grow-1 d-flex flex-column h-100 overflow-auto">
        <LoadingDataLoader v-if="isLoadingData"></LoadingDataLoader>
        <ErrorOnLoadingDataFeedback v-else-if="errorLoadingData"></ErrorOnLoadingDataFeedback>
        <template v-else>
          <ScadenzariListSwitcher :viewMode="viewMode" @update:viewMode="setViewMode"/>
          <ScadenzariListTable v-if="viewMode === 'crediti'" class="report-texts-size" :scadenzari="results" :edit-enabled="userIsAdmin || userIsContextCompanyConsultant || userIsContextCompanyOwner" @delete="removeScadenzario" />
        </template>
      </div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';
import loadingDataMixin from '../../../../../mixins/loadingData';
import computedFinancialDataMixin from '../../../../../mixins/computedFinancialData';
import confirmWithModalMixin from '../../../../../libs/Confirm/mixins/confirmWithModal';
import formatMoneyFilter from '../../../../../filters/formatMoney';

export default {
  name: 'page-operative-company-data-analysis-scadenzari-list',
  mixins: [operativePageMixin, loadingDataMixin, computedFinancialDataMixin, confirmWithModalMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    ErrorOnLoadingDataFeedback: () => import('../../../../components/Operative/ErrorOnLoadingDataFeedback'),
    LoadingDataLoader: () => import('../../../../components/Operative/LoadingDataLoader'),
    ScadenzariListTable: () => import('../../../../components/Operative/ListTable/ScadenzariListTable'),
    ScadenzariListSwitcher: () => import('../../../../components/Operative/ScadenzariListSwitcher'),
    AppRouterLink: () => import('../../../../components/Layout/AppRouterLink'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  data () {
    return {
      data: null,
      results: null,
      viewMode: 'crediti',
    };
  },
  methods: {
    setViewMode (mode) {
      if (mode === 'forecast') {
        this.retrieveForecastData();
      } else if (mode === 'list') {
        this.retrieveListData();
      }
      this.viewMode = mode;
    },
    retrieveListData () {
      if (!this.company) {
        return;
      }

      this.resetErrorOnLoadingData();
      this.setDataLoading();
      this.$api.getScadenzari(this.company?.id)
        .then(res => {
          this.results = res?.data?.scadenzari || [];
        })
        .catch(this.setErrorOnLoadingData)
        .finally(this.setDataLoaded)
      ;
    },
    removeScadenzario (id) {
      this.confirm('Cancellare lo scadenzario selezionato? L\'operazione è irreversibile', 'Ok', 'Annulla')
        .then(confirmed => {
          if (!confirmed) {
            return;
          }

          this.$api.deleteScadenzario(this.company.id, id).then(() => this.retrieveListData()).catch(this.$log.error);
        })
      ;
    },
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        this.setViewMode('crediti');
      },
    },
  },
};

</script>
